<!-- svelte-ignore -->
<div bind:this={target} on:click={redirectClick} />


<script lang="ts">
    import { createEventDispatcher, tick } from "svelte";

    export let node: Node;
    export let runScripts: boolean = false;
    
    let target: HTMLDivElement;

    const dispatcher = createEventDispatcher();

    function unpackOne(node: Node): Node[] {
        if (node instanceof Document) {
            node = node.body;
        }
        if (node instanceof HTMLBodyElement) {
            return Array.from(node.childNodes);
        }

        return [node];
    }

    function redirectClick(event: MouseEvent) {
        dispatcher("click", {event});
    }

    $: {
        if (!!target && !!node) {
            const scripts: string[] = [];
            while (target.hasChildNodes())
                target.removeChild(target.childNodes[0]);

            for (let child of unpackOne(node)) {
                const clone = child.cloneNode(true);
                target.append(clone);
                if (runScripts && clone instanceof HTMLElement) {
                    Array.from(clone.querySelectorAll("script")).map(s => s.innerText).forEach(s => scripts.push(s));
                }
            }

            if (scripts.length > 0) tick().then(() => tick().then(() => scripts.forEach(s => (0, window.eval)(s))));
        }
    }
</script>

